import { t } from '../i18n'
import {useEffect, useRef, useState} from "react";

import ConfigDialog from './ConfigDialog'

import './Config.css';
import {DisplayParamsType, DivisionInfo} from "./DisplayParams";

export type DisplayType = 'audience' | 'field' | 'pit' | 'sponsor' | 'cmpBar';
export type ScoringBarLocation = 'bottom' | 'top';
export type AllianceOrientation = 'standard' | 'flipped';
export type AllianceSelectionStyle = 'classic' | 'hybrid';
export type AwardsStyle = 'overlay' | 'classic';
export type DualDivisionRankingStyle = 'sideBySide' | 'stacked';
export type RankingsFontSize = 'larger' | 'smaller';

export interface DisplayConfig {
    name?: string,
    type: DisplayType,
    bindToField: string,
    scoringBarLocation: ScoringBarLocation,
    allianceOrientation: AllianceOrientation,
    mute: boolean,
    muteRandomizationResults: boolean,
    inspectionGroupDivision: boolean,
    fieldStyleTimer: boolean,
    overlay: boolean,
    overlayColor: string,
    allianceSelectionStyle: AllianceSelectionStyle,
    awardsStyle: AwardsStyle,
    dualDivisionRankingStyle: DualDivisionRankingStyle,
    rankingsFontSize: RankingsFontSize,
    showMeetRankings: boolean,
    rankingsAllTeams: boolean,
    divisionOrder?: number[]
}

export default function Config({config, setConfig, isConfigured, fieldCount, isDualDivisionParent, style, showMeetRankings, eventName, cursorMovedRecently, divisions} : {
    config: DisplayConfig,
    setConfig: (cfg : DisplayConfig) => void,
    isConfigured: boolean,
    fieldCount: number,
    isDualDivisionParent?: boolean,
    style: DisplayParamsType["style"],
    showMeetRankings?: boolean,
    eventName: string,
    cursorMovedRecently: boolean,
    divisions?: Record<number, DivisionInfo>
}) {
    const [showConfig, setShowConfig] = useState(isConfigured);

    useEffect(() => {
        if(showConfig) {
            return;
        }

        const clickListener = function( event : MouseEvent ) {
            if ( event.ctrlKey || event.shiftKey) {
                setShowConfig(true)
            }
        }

        document.addEventListener('click', clickListener);

        return () => {
            if(clickListener) {
                document.removeEventListener('click', clickListener)
            }
        }
    }, [showConfig])

    const simpleDivisions: Record<number, string> = {}
    Object.entries(divisions || {}).forEach(([key, value]) => {
        simpleDivisions[parseInt(key)] = value.name
    })

    return <>
        <button key={'button'} className={`configButton ${(cursorMovedRecently && !showConfig) ? 'in' :''}`} onClick={() => {setShowConfig(true)}} title={t`Configure display`}><i className={style.startsWith('remote') || style.startsWith('cloud') ? 'fa fa-cog' : 'fas fa-cog'} /></button>
        <ConfigDialog show={showConfig} handleClose={() => {setShowConfig(false)}} fieldCount={fieldCount} config={config} setConfig={setConfig} style={style} isDualDivisionParent={isDualDivisionParent} showMeetRankings={showMeetRankings} eventName={eventName} divisions={simpleDivisions}/>
    </>
}